import {useEffect, useState} from "react";
import {
    LocationsToRearrangeWithExtensionsLazyQueryHookResult,
    LocationsToRearrangeWithExtensionsQuery,
    useLocationsToRearrangeWithExtensionsLazyQuery,
} from "../queries.generated";

export default class DataSource {
    data: LocationsToRearrangeWithExtensionsQuery;
    protected readonly setData: (data: LocationsToRearrangeWithExtensionsQuery) => void;

    private query: LocationsToRearrangeWithExtensionsLazyQueryHookResult[0];

    constructor(locationId: number) {
        [this.data, this.setData] = useState<LocationsToRearrangeWithExtensionsQuery>();
        [this.query] = useLocationsToRearrangeWithExtensionsLazyQuery();

        useEffect(() => {
            this.fetchData(locationId);
        }, [locationId]);
    }

    async fetchData(locationId: number) {
        this.setData(
            (
                await this.query({
                    variables: {locationId},
                    fetchPolicy: "no-cache",
                })
            ).data,
        );
    }
}
